import React, { useEffect, useRef, useState } from "react";
import Iconify from "../../../layouts/components/iconify/iconify";
import DatePicker from "../../../components/ui/inputs/datePicker/DatePicker";
import { formatDateRangeLabel } from "../teamOverviewUtils";

/**
 * Date-range filter field with the same labeled shell as OverviewFilterField.
 * Clicking the shell opens a small panel with From / To date pickers.
 */
const OverviewDateRangeField = ({ fromDate, toDate, onChangeFrom, onChangeTo, label = "Date Range" }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const displayValue = formatDateRangeLabel(fromDate, toDate) || "Select dates";

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  return (
    <div className="overview-filter-field overview-date-range-field" ref={rootRef}>
      <button
        type="button"
        className={`overview-filter-shell ${open ? "is-open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="overview-filter-icon" aria-hidden="true">
          <Iconify icon="mdi:calendar-range-outline" />
        </span>
        <div className="overview-filter-meta">
          <span className="overview-filter-label">{label}</span>
          <span className="overview-filter-value">{displayValue}</span>
        </div>
        <span className="overview-filter-chevron" aria-hidden="true">
          <Iconify icon="mdi:chevron-down" />
        </span>
      </button>

      {open ? (
        <div className="overview-date-range-panel">
          <div className="overview-date-range-row">
            <span className="overview-date-range-caption">From</span>
            <DatePicker
              selected={fromDate}
              onChange={onChangeFrom}
              placeholder="From Date"
              datePickerConfig={{ format: "dd MMM yyyy", allowClear: true }}
            />
          </div>
          <div className="overview-date-range-row">
            <span className="overview-date-range-caption">To</span>
            <DatePicker
              selected={toDate}
              onChange={onChangeTo}
              placeholder="To Date"
              datePickerConfig={{ format: "dd MMM yyyy", allowClear: true }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OverviewDateRangeField;
